import React from "react";

function TextAreaComponent(props) {

    return (
        <div className="mb-2">
            {props.label ? (<label htmlFor={props.id} className="form-label ">{props.label}</label>) : ("")}
            <textarea className="form-control custom-text-area" 
            placeholder={props.placeholder} 
            id={props.id} key={props.id} 
            style={{ resize: 'none' }}
            disabled={props.disabled}
            onChange={props.handleInput}></textarea>
        </div>
    );
}

export default TextAreaComponent;






